// @ts-nocheck
// /c/:code — FBZipper's Facebook-connect page. Generated from zubipost/src/connect/
// ConnectPage.tsx (the same page Zubipost serves at /app/connect/<code>): keep the two in
// step. Differences: FBZipper logo, Hebrew by default (?lang=en for English), "back"
// goes to the console, and it lives in the console app so every /c/<code> link already
// sent keeps working. The previous page stays at /c-classic/:code.
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import './connect-mobile.scss';

const API_URL = process.env.REACT_APP_API_URL || '';

const PATHS: Record<string, string> = {
  alert: 'M12 9v4M12 17h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z',
  eye: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  keyboard: 'M2 6h20v12H2zM6 10h.01M10 10h.01M14 10h.01M18 10h.01M7 14h10',
  clipboard: 'M9 3h6v3H9zM8 5H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2',
  copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
  refresh: 'M21 12a9 9 0 1 1-2.64-6.36M21 3v6h-6',
  user: 'M20 21a8 8 0 0 0-16 0M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10z',
  key: 'M21 2l-9.6 9.6M15.5 7.5l3 3L22 7l-3-3M11.4 11.6a5.5 5.5 0 1 1-7.8 7.8 5.5 5.5 0 0 1 7.8-7.8z',
  check: 'M20 6 9 17l-5-5',
};
function Icon({ name, size = 20 }: { name: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  );
}
const Logo = ({ size = 26 }: { size?: number }) => <img src="/landing-assets/fbzipper-logo.png" alt="FBZipper" style={{ height: size, width: 'auto', display: 'block' }} />;

type Phase = 'loading' | 'form' | 'connecting' | 'streaming' | 'done' | 'expired' | 'error' | 'nostream';
type Focus = { blind?: boolean; rect: { x: number; y: number; w: number; h: number } | null; value: string; type: string | null; placeholder?: string; inputmode?: string; autocomplete?: string; name?: string; maxlength?: number | null } | null;

const he = new URLSearchParams(window.location.search).get('lang') !== 'en';
const T = he
  ? { title: 'חיבור פייסבוק', user: 'אימייל או טלפון של פייסבוק', pass: 'סיסמה', go: 'המשך', sub: 'נמלא את הפרטים בשבילכם בדף ההתחברות של פייסבוק. אתם רק מאשרים.', connecting: 'פותחים את פייסבוק…', paste: 'הדבקה', copy: 'העתקה', reload: 'רענון', copied: 'הועתק', pasted: 'הודבק', tapField: 'הקישו קודם על שדה', noClip: 'אין מה להדביק', done: 'מחוברים!', doneBody: 'הפרופיל מחובר לפייסבוק, והפוסטים ימשיכו לצאת לבד.', back: 'חזרה ל-FBZipper', expired: 'הקישור פג תוקף', expiredBody: 'בקשו קישור התחברות חדש.', error: 'לא הצלחנו לפתוח את פייסבוק', errorBody: 'נסו לרענן את הדף בעוד רגע.', hint: 'הקישו על שדה ואז ⌨ מקלדת · החליקו כדי לגלול', typing: 'הקלדה', doneTyping: 'סיום', keyboard: 'מקלדת', fillLabel: 'מילוי לשדה שהקשתם:', fillUser: 'שם משתמש', fillPass: 'סיסמה', filledUser: 'שם המשתמש הוזן', filledPass: 'הסיסמה הוזנה', blindHint: 'מקלידים לשדה שהקשתם עליו', codeHint: 'הקוד מפייסבוק (SMS או אפליקציה)', reloading: 'מרעננים…', lost: 'החיבור לדפדפן נותק', reconnect: 'להתחבר מחדש', noStream: 'לא הצלחנו לפתוח את דף ההתחברות של פייסבוק כרגע. נסו שוב בעוד כמה דקות.', retry: 'לנסות שוב' }
  : { title: 'Connect Facebook', user: 'Facebook email or phone', pass: 'Password', go: 'Continue', sub: "We'll fill these in on Facebook's login page for you. You just confirm.", connecting: 'Opening Facebook…', paste: 'Paste', copy: 'Copy', reload: 'Reload', copied: 'Copied', pasted: 'Pasted', tapField: 'Tap a field first', noClip: 'Nothing to paste', done: "You're connected!", doneBody: 'Your profile is connected to Facebook, and your posts keep going out on their own.', back: 'Back to FBZipper', expired: 'This link has expired', expiredBody: 'Ask for a new sign-in link.', error: "We couldn't open Facebook", errorBody: 'Try refreshing this page in a moment.', hint: 'Tap a field, then ⌨ Keyboard to type · swipe to scroll', typing: 'Typing', doneTyping: 'Done', keyboard: 'Keyboard', fillLabel: 'Fill the tapped field:', fillUser: 'Username', fillPass: 'Password', filledUser: 'Username filled in', filledPass: 'Password filled in', blindHint: 'Typing into the field you tapped', codeHint: 'Your Facebook code (SMS or app)', reloading: 'Reloading…', lost: 'The connection to the browser dropped', reconnect: 'Reconnect', noStream: "We couldn't open Facebook's login page right now. Try again in a few minutes.", retry: 'Try again' };

const clamp = (v: number, lo: number, hi: number) => Math.max(lo, Math.min(hi, v));

// "Back to FBZipper" goes to the console.
const BACK_HREF = '/';
const BackButton = ({ label, primary }: { label: string; primary?: boolean }) => (
  <a className={primary ? 'cx-go cx-back' : 'cx-back ghost'} href={BACK_HREF}>{label}</a>
);

// Pick the phone keyboard and autofill for a remote field.
// Facebook's two-factor / checkpoint / approval screens.
const CODE_SCREEN = /checkpoint|two_step|two_factor|twofactor|approvals|login\/device|confirmemail|recover\/code|\/auth_platform/i;

function keyboardFor(f: NonNullable<Focus>, url: string) {
  const type = String(f.type || 'text').toLowerCase();
  if (f.blind && CODE_SCREEN.test(url)) return { type: 'text', inputMode: 'numeric' as const, autoComplete: 'one-time-code' };
  const hint = `${f.name || ''} ${f.placeholder || ''} ${f.autocomplete || ''}`.toLowerCase();
  const isCode = f.autocomplete === 'one-time-code' || /\b(code|otp|approvals?_code|verification|קוד)\b/.test(hint) || (!!f.maxlength && f.maxlength <= 8 && (f.inputmode === 'numeric' || type === 'number' || type === 'tel'));
  if (type === 'password') return { type: 'password', inputMode: undefined, autoComplete: 'current-password' };
  if (isCode) return { type: 'text', inputMode: 'numeric' as const, autoComplete: 'one-time-code' };
  if (type === 'email' || /email|mail/.test(hint)) return { type: 'email', inputMode: 'email' as const, autoComplete: 'username' };
  if (type === 'tel') return { type: 'tel', inputMode: 'tel' as const, autoComplete: 'tel' };
  if (/user|login|phone|contact_point/.test(hint)) return { type: 'text', inputMode: 'email' as const, autoComplete: 'username' };
  return { type: 'text', inputMode: (f.inputmode || undefined) as 'text' | undefined, autoComplete: 'off' };
}

function ConnectPage({ code }: { code: string }) {
  const [phase, setPhase] = useState<Phase>('loading');
  const [profileName, setProfileName] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [focus, setFocus] = useState<Focus>(null);
  const [toast, setToast] = useState('');
  const [status, setStatus] = useState('');
  const ws = useRef<WebSocket | null>(null);
  const img = useRef<HTMLImageElement>(null);
  const stage = useRef<HTMLDivElement>(null);
  const overlay = useRef<HTMLInputElement>(null);
  const meta = useRef<{ deviceWidth: number; deviceHeight: number } | null>(null);
  const focusRef = useRef<Focus>(null);
  const creds = useRef({ u: '', p: '' });
  const autofilled = useRef(false);
  const poll = useRef<number | undefined>(undefined);
  // Set when the bot says it understands real touch (newer fleet-client). Until then
  // taps are sent as clicks and swipes as wheel scrolling, which every bot supports.
  const touchOk = useRef(false);
  const [pageUrl, setPageUrl] = useState('');
  const [linkDown, setLinkDown] = useState(false);
  const wsUrlRef = useRef('');
  // Opening Facebook often fails once while the browser session is still starting: retry
  // quietly (loading screen, 2s apart) and show the error only after RETRIES failures in a row.
  const RETRIES = 10;
  const tries = useRef(0);
  const phaseRef = useRef<Phase>('loading');
  phaseRef.current = phase;
  const ring = useRef<HTMLDivElement>(null);
  const typedAt = useRef(0);
  // Phones fire imitation mouse events after a touch; ignore them so a tap isn't two clicks.
  const lastTouch = useRef(0);
  // How far the on-screen keyboard covers the bottom of the screen (px).
  const [kbInset, setKbInset] = useState(0);

  useEffect(() => {
    document.documentElement.lang = he ? 'he' : 'en';
    document.documentElement.dir = he ? 'rtl' : 'ltr';
    document.title = `${T.title} · FBZipper`;
  }, []);

  const flash = (m: string) => {
    setToast(m);
    window.setTimeout(() => setToast(''), 1600);
  };
  const send = (o: Record<string, unknown>) => {
    const s = ws.current;
    if (s && s.readyState === WebSocket.OPEN) s.send(JSON.stringify(o));
  };

  // ── boot ──
  useEffect(() => {
    let cancelled = false;
    const boot = async (attempt: number) => {
      try {
        const r = await fetch(`${API_URL}/connect-link/${encodeURIComponent(code)}`);
        if (r.status === 410) return !cancelled && setPhase('expired');
        if (!r.ok) throw new Error();
        const info = await r.json();
        if (cancelled) return;
        setProfileName(info.profile?.name || '');
        // autoGEN_… is the placeholder name of a profile that was never connected, not a login.
        const u = String(info.profile?.facebook_username || '');
        if (u && !/^autoGEN_/i.test(u)) setUsername(u);
        if (info.profile?.facebook_password) setPassword(info.profile.facebook_password);
        // ?test=1 opens the live browser even for a profile that's already logged in.
        const test = new URLSearchParams(window.location.search).has('test');
        setPhase(info.profile?.is_logged_in && !test ? 'done' : 'form');
      } catch {
        if (cancelled) return;
        if (attempt < RETRIES) window.setTimeout(() => !cancelled && boot(attempt + 1), 2000);
        else setPhase('error');
      }
    };
    boot(1);
    return () => {
      cancelled = true;
      window.clearInterval(poll.current);
      try { ws.current?.close(); } catch {}
    };
  }, [code]);

  // ── geometry: this screen ↔ remote page CSS px ──
  const geom = () => {
    const el = img.current;
    if (!el) return null;
    const box = el.getBoundingClientRect();
    const dw = meta.current?.deviceWidth || el.naturalWidth || box.width;
    const dh = meta.current?.deviceHeight || el.naturalHeight || box.height;
    const natW = el.naturalWidth || dw;
    const natH = el.naturalHeight || dh;
    const k = Math.min(box.width / natW, box.height / natH) || 1;
    const rw = natW * k;
    const rh = natH * k;
    return { box, dw, dh, rw, rh, ox: (box.width - rw) / 2, oy: (box.height - rh) / 2 };
  };
  const toPage = (cx: number, cy: number) => {
    const g = geom();
    if (!g) return { x: 0, y: 0 };
    return {
      x: clamp((cx - g.box.left - g.ox) / g.rw, 0, 1) * g.dw,
      y: clamp((cy - g.box.top - g.oy) / g.rh, 0, 1) * g.dh,
    };
  };
  // A ring on the page marks the field being typed into; the typing itself happens in
  // the bar docked above the keyboard, so it's never hidden behind the keyboard.
  const placeOverlay = () => {
    const f = focusRef.current;
    const el = ring.current;
    const g = geom();
    if (!f || !f.rect || !el || !g) return;
    el.style.left = `${g.ox + (f.rect.x / g.dw) * g.rw - 3}px`;
    el.style.top = `${g.oy + (f.rect.y / g.dh) * g.rh - 3}px`;
    el.style.width = `${(f.rect.w / g.dw) * g.rw + 6}px`;
    el.style.height = `${(f.rect.h / g.dh) * g.rh + 6}px`;
  };

  // Tell the bot this phone's real screen size, so the page renders 1:1.
  const sendViewport = () => {
    const box = stage.current?.getBoundingClientRect();
    if (!box) return;
    send({ kind: 'cdp_input', event: 'viewport', width: Math.round(box.width), height: Math.round(box.height), dpr: Math.min(2, window.devicePixelRatio || 1) });
  };
  useEffect(() => {
    if (phase !== 'streaming') return;
    let t: number | undefined;
    let lastW = window.innerWidth;
    const on = () => {
      if (window.innerWidth === lastW) return; // keyboard opening, not a rotation
      lastW = window.innerWidth;
      window.clearTimeout(t);
      t = window.setTimeout(sendViewport, 300);
    };
    window.addEventListener('orientationchange', on);
    window.addEventListener('resize', on);
    return () => {
      window.removeEventListener('orientationchange', on);
      window.removeEventListener('resize', on);
    };
  }, [phase]);

  // Keep the typing bar sitting on top of the on-screen keyboard.
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const on = () => setKbInset(Math.max(0, Math.round(window.innerHeight - (vv.offsetTop + vv.height))));
    vv.addEventListener('resize', on);
    vv.addEventListener('scroll', on);
    return () => {
      vv.removeEventListener('resize', on);
      vv.removeEventListener('scroll', on);
    };
  }, []);

  // ── credentials → session → stream ──
  const start = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password) return;
    creds.current = { u: username.trim(), p: password };
    autofilled.current = false;
    setPhase('connecting');
    setStatus(T.connecting);
    try {
      await fetch(`${API_URL}/connect-link/${encodeURIComponent(code)}/credentials`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username: creds.current.u, password: creds.current.p }),
      });
    } catch {}
    tries.current = 0;
    connectSession();
  };

  // Still failing → the loading screen stays, another try in 2s. False = out of tries.
  const retryLater = () => {
    if (tries.current >= RETRIES - 1) return false;
    tries.current += 1;
    setPhase('connecting');
    setStatus(T.connecting);
    window.setTimeout(connectSession, 2000);
    return true;
  };

  const connectSession = async () => {
    let wsUrl = '';
    try {
      const r = await fetch(`${API_URL}/connect-link/${encodeURIComponent(code)}/session`, { method: 'POST' });
      if (r.status === 410) return setPhase('expired');
      wsUrl = (await r.json()).ws_url || '';
    } catch {}
    if (!wsUrl) {
      if (!retryLater()) setPhase('error');
      return;
    }
    wsUrlRef.current = wsUrl;
    openStream(wsUrl);
    window.clearInterval(poll.current);
    poll.current = window.setInterval(async () => {
      try {
        const r = await fetch(`${API_URL}/connect-link/${encodeURIComponent(code)}/status`);
        const d = await r.json();
        if (d?.is_logged_in && !new URLSearchParams(window.location.search).has('test')) {
          window.clearInterval(poll.current);
          setPhase('done');
          try { ws.current?.close(); } catch {}
        }
      } catch {}
    }, 4000);
  };

  const openStream = (url: string) => {
    let s: WebSocket;
    try { s = new WebSocket(url); } catch {
      if (!retryLater()) setPhase('error');
      return;
    }
    ws.current = s;
    // No picture within 25s, or the connection drops before one: a new try (retryLater), and
    // "couldn't open Facebook" only once the tries run out.
    let failed = false;
    const fail = () => {
      window.clearTimeout(giveUp);
      if (failed || ws.current !== s || phaseRef.current !== 'connecting') return;
      failed = true;
      try { s.close(); } catch {}
      if (!retryLater()) setPhase('nostream');
    };
    const giveUp = window.setTimeout(fail, 25000);
    s.onerror = fail;
    s.onclose = () => {
      window.clearTimeout(giveUp);
      if (phaseRef.current === 'connecting') return fail();
      setStatus('');
      setPhase((p) => {
        if (p === 'streaming' && ws.current === s) setLinkDown(true);
        return p;
      });
    };
    s.onopen = () => setLinkDown(false);
    s.onmessage = (ev) => {
      let m: any;
      try { m = JSON.parse(ev.data); } catch { return; }
      if (m.kind === 'screencast_frame') {
        if (img.current) img.current.src = `data:image/jpeg;base64,${m.data}`;
        meta.current = m.metadata || null;
        if (focusRef.current) placeOverlay();
        setPhase((p) => (p === 'connecting' ? 'streaming' : p));
      } else if (m.kind === 'screencast_started') {
        window.setTimeout(sendViewport, 200);
      } else if (m.kind === 'input_focused') {
        focusRef.current = m;
        setFocus(m);
        window.setTimeout(() => {
          const el = overlay.current;
          if (!el) return;
          if (performance.now() - typedAt.current > 1500) el.value = m.value || '';
          placeOverlay();
          // Android opens the keyboard here (still inside the tap's activation window);
          // on iPhone the bar shows and one tap on it opens the keyboard.
          try { el.focus({ preventScroll: true }); } catch {}
          try { el.setSelectionRange(el.value.length, el.value.length); } catch {}
        }, 0);
      } else if (m.kind === 'input_blurred') {
        focusRef.current = null;
        setFocus(null);
        try { overlay.current?.blur(); } catch {}
      } else if (m.kind === 'page_url') {
        if (Array.isArray(m.caps)) {
          touchOk.current = m.caps.includes('touch');
          return;
        }
        if (typeof m.selection === 'string') {
          if (m.selection) {
            navigator.clipboard?.writeText(m.selection).then(() => flash(T.copied), () => flash(m.selection.slice(0, 40)));
          } else flash(T.tapField);
          return;
        }
        setPageUrl(String(m.url || ''));
        if (!autofilled.current && /\/login/i.test(String(m.url || ''))) {
          autofilled.current = true;
          window.setTimeout(() => send({ kind: 'autofill_login', username: creds.current.u, password: creds.current.p }), 800);
        }
      } else if (m.kind === 'screencast_error') {
        setStatus(String(m.error || ''));
      }
    };
  };

  // ── touch: real touches + a fling after release ──
  const drag = useRef<{ x: number; y: number; t: number; vy: number; moved: boolean; sx: number; sy: number } | null>(null);
  const fling = useRef<number | undefined>(undefined);
  const onTouchStart = (e: React.TouchEvent) => {
    const t = e.touches[0];
    if (!t) return;
    lastTouch.current = Date.now();
    window.clearInterval(fling.current);
    drag.current = { x: t.clientX, y: t.clientY, t: performance.now(), vy: 0, moved: false, sx: t.clientX, sy: t.clientY };
    if (touchOk.current) send({ kind: 'cdp_input', event: 'touch', type: 'touchStart', points: [toPage(t.clientX, t.clientY)] });
  };
  const onTouchMove = (e: React.TouchEvent) => {
    const t = e.touches[0];
    const d = drag.current;
    if (!t || !d) return;
    const now = performance.now();
    const dy = t.clientY - d.y;
    d.vy = dy / Math.max(1, now - d.t);
    d.x = t.clientX;
    d.y = t.clientY;
    d.t = now;
    if (Math.hypot(t.clientX - d.sx, t.clientY - d.sy) > 8) d.moved = true;
    if (touchOk.current) {
      send({ kind: 'cdp_input', event: 'touch', type: 'touchMove', points: [toPage(t.clientX, t.clientY)] });
    } else if (d.moved) {
      // Older bot: scroll the page by the finger's movement with the wheel.
      const g = geom();
      const at = toPage(t.clientX, t.clientY);
      send({ kind: 'cdp_input', event: 'mouse', type: 'mouseWheel', x: at.x, y: at.y, deltaX: 0, deltaY: -dy * (g ? g.dh / g.rh : 1) });
    }
  };
  const onTouchEnd = () => {
    lastTouch.current = Date.now();
    const d = drag.current;
    drag.current = null;
    if (touchOk.current) send({ kind: 'cdp_input', event: 'touch', type: 'touchEnd', points: [] });
    if (!d) return;
    // A tap. The keyboard only opens if the page reports that a text field got focus.
    if (!d.moved) {
      if (!touchOk.current) {
        // Older bot: a tap is a click.
        const p = toPage(d.sx, d.sy);
        send({ kind: 'cdp_input', event: 'mouse', type: 'mousePressed', x: p.x, y: p.y, button: 'left', clickCount: 1 });
        send({ kind: 'cdp_input', event: 'mouse', type: 'mouseReleased', x: p.x, y: p.y, button: 'left', clickCount: 1 });
      }
      return;
    }
    // A flick: keep scrolling for a moment, like a phone does.
    let v = d.vy;
    if (Math.abs(v) < 0.5) return;
    const g = geom();
    const k = g ? g.dh / g.rh : 1;
    const at = toPage(d.x, d.y);
    fling.current = window.setInterval(() => {
      v *= 0.9;
      if (Math.abs(v) < 0.08) return window.clearInterval(fling.current);
      send({ kind: 'cdp_input', event: 'mouse', type: 'mouseWheel', x: at.x, y: at.y, deltaX: 0, deltaY: -v * 16 * k });
    }, 16);
  };
  // Desktop testing: clicks and the wheel still work.
  const onMouseDown = (e: React.MouseEvent) => {
    if (Date.now() - lastTouch.current < 1000) return;
    const p = toPage(e.clientX, e.clientY);
    send({ kind: 'cdp_input', event: 'mouse', type: 'mousePressed', x: p.x, y: p.y, button: 'left', clickCount: 1 });
  };
  const onMouseUp = (e: React.MouseEvent) => {
    if (Date.now() - lastTouch.current < 1000) return;
    const p = toPage(e.clientX, e.clientY);
    send({ kind: 'cdp_input', event: 'mouse', type: 'mouseReleased', x: p.x, y: p.y, button: 'left', clickCount: 1 });
  };
  const onWheel = (e: React.WheelEvent) => {
    const p = toPage(e.clientX, e.clientY);
    send({ kind: 'cdp_input', event: 'mouse', type: 'mouseWheel', x: p.x, y: p.y, deltaX: e.deltaX, deltaY: e.deltaY });
  };

  // ── keyboard bridge ──
  const onInput = (e: React.FormEvent<HTMLInputElement>) => {
    typedAt.current = performance.now();
    send({ kind: 'input_set_text', value: e.currentTarget.value });
  };
  // "Done": leave the field and close the keyboard.
  const doneTyping = () => {
    send({ kind: 'input_clear_focus' });
    focusRef.current = null;
    setFocus(null);
    try { overlay.current?.blur(); } catch {}
  };
  const onKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      send({ kind: 'cdp_input', event: 'key', type: 'keyDown', key: 'Enter', code: 'Enter' });
      send({ kind: 'cdp_input', event: 'key', type: 'keyUp', key: 'Enter', code: 'Enter' });
    }
  };
  const paste = async () => {
    const el = overlay.current;
    if (!focusRef.current || !el) return flash(T.tapField);
    let text = '';
    try { text = await navigator.clipboard.readText(); } catch {}
    if (!text) return flash(T.noClip);
    const a = el.selectionStart ?? el.value.length;
    const b = el.selectionEnd ?? el.value.length;
    el.value = el.value.slice(0, a) + text.trim() + el.value.slice(b);
    send({ kind: 'input_set_text', value: el.value });
    try { el.focus({ preventScroll: true }); } catch {}
    flash(T.pasted);
  };
  const copy = () => send({ kind: 'cdp_input', event: 'selection' });
  // Fill the login details from the first screen into the field last tapped on
  // Facebook's page (replaces what's there). Handy when the automatic fill misses.
  const fill = (which: 'u' | 'p') => {
    const v = which === 'u' ? creds.current.u : creds.current.p;
    if (!v) return;
    send({ kind: 'input_set_text', value: v });
    if (overlay.current && focusRef.current) overlay.current.value = v;
    flash(which === 'u' ? T.filledUser : T.filledPass);
  };
  // Reconnect a dropped stream with a fresh session (the old link may have expired).
  const reconnect = async () => {
    setLinkDown(false);
    try {
      const r = await fetch(`${API_URL}/connect-link/${encodeURIComponent(code)}/session`, { method: 'POST' });
      const u = (await r.json()).ws_url || wsUrlRef.current;
      wsUrlRef.current = u;
      openStream(u);
    } catch {
      setLinkDown(true);
    }
  };
  const reload = () => {
    if (!ws.current || ws.current.readyState !== WebSocket.OPEN) return reconnect();
    send({ kind: 'page_reload' });
    flash(T.reloading);
  };
  // ⌨: type into whatever field was last tapped on Facebook's page. Works even when
  // the page can't tell us which field got focus (e.g. after Facebook changes page).
  const openKeyboard = () => {
    const el = overlay.current;
    if (!el) return;
    if (!focusRef.current) {
      const f: Focus = { blind: true, rect: null, value: '', type: null, placeholder: CODE_SCREEN.test(pageUrl) ? T.codeHint : T.blindHint };
      focusRef.current = f;
      setFocus(f);
      el.value = '';
    }
    try { el.focus(); } catch {}
  };

  const kb = focus ? keyboardFor(focus, pageUrl) : null;

  if (phase === 'loading') return <div className="cx-center"><span className="cx-spin" /></div>;
  if (phase === 'nostream') {
    return (
      <div className="cx-center">
        <span className="cx-badge bad"><Icon name="alert" size={34} /></span>
        <h1>{T.error}</h1>
        <p>{T.noStream}</p>
        <button type="button" className="cx-go" onClick={() => { window.clearInterval(poll.current); try { ws.current?.close(); } catch {} setPhase('form'); }}>{T.retry}</button>
        <BackButton label={T.back} />
      </div>
    );
  }
  if (phase === 'done' || phase === 'expired' || phase === 'error') {
    const ok = phase === 'done';
    return (
      <div className="cx-center">
        <span className={`cx-badge ${ok ? 'ok' : 'bad'}`}><Icon name={ok ? 'check' : 'alert'} size={34} /></span>
        <h1>{ok ? T.done : phase === 'expired' ? T.expired : T.error}</h1>
        <p>{ok ? T.doneBody : phase === 'expired' ? T.expiredBody : T.errorBody}</p>
        <BackButton label={T.back} primary={ok} />
      </div>
    );
  }

  if (phase === 'form') {
    return (
      <div className="cx-form-page">
        <header className="cx-brand"><Logo size={30} /></header>
        <form className="cx-form" onSubmit={start}>
          <span className="cx-fb">f</span>
          <h1>{T.title}{profileName ? ` · ${profileName}` : ''}</h1>
          <p>{T.sub}</p>
          <input id="cx-user" name="username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder={T.user} autoComplete="username" inputMode="email" dir="ltr" />
          <div className="cx-pass">
            <input id="cx-pass" name="password" type={showPass ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} placeholder={T.pass} autoComplete="current-password" dir="ltr" />
            <button type="button" onClick={() => setShowPass(!showPass)} aria-label={showPass ? 'Hide password' : 'Show password'}><Icon name="eye" size={18} /></button>
          </div>
          <button type="submit" className="cx-go" disabled={!username.trim() || !password}>{T.go}</button>
        </form>
      </div>
    );
  }

  return (
    <div className="cx">
      <header className="cx-bar">
        <Logo size={24} />
        <div className="cx-tools">
          <button type="button" className="cx-kb" onClick={openKeyboard}><Icon name="keyboard" size={17} /><span>{T.keyboard}</span></button>
          <button type="button" onClick={paste}><Icon name="clipboard" size={17} /><span>{T.paste}</span></button>
          <button type="button" onClick={copy}><Icon name="copy" size={17} /><span>{T.copy}</span></button>
          <button type="button" onClick={reload} aria-label={T.reload}><Icon name="refresh" size={17} /><span>{T.reload}</span></button>
        </div>
      </header>
      <div className="cx-fill">
        <span>{T.fillLabel}</span>
        <button type="button" onClick={() => fill('u')} disabled={!creds.current.u}><Icon name="user" size={15} /> {T.fillUser}</button>
        <button type="button" onClick={() => fill('p')} disabled={!creds.current.p}><Icon name="key" size={15} /> {T.fillPass}</button>
      </div>
      <div
        className="cx-stage"
        ref={stage}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onTouchCancel={onTouchEnd}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onWheel={onWheel}
      >
        <img ref={img} alt="" className="cx-screen" draggable={false} />
        {phase === 'connecting' && <div className="cx-wait"><span className="cx-spin" /><small>{status}</small></div>}
        {linkDown && (
          <div className="cx-wait lost" role="status">
            <Icon name="alert" size={28} />
            <b>{T.lost}</b>
            <button type="button" className="cx-go" onClick={reconnect}>{T.reconnect}</button>
          </div>
        )}
        <div ref={ring} className={`cx-ring${focus ? ' on' : ''}`} aria-hidden="true" />
      </div>
      <div className={`cx-typebar${focus ? ' on' : ''}`} style={{ bottom: kbInset }}>
        <label htmlFor="cx-type">{focus?.placeholder || (kb?.type === 'password' ? T.pass : T.typing)}</label>
        <div className="cx-typerow">
        <input
          id="cx-type"
          ref={overlay}
          className="cx-field"
          type={kb?.type || 'text'}
          inputMode={kb?.inputMode}
          autoComplete={kb?.autoComplete || 'off'}
          name={kb?.autoComplete === 'one-time-code' ? 'otp' : kb?.type === 'password' ? 'password' : 'field'}
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
          dir="auto"
          onInput={onInput}
          onKeyDown={onKey}
          aria-label={focus?.placeholder || 'Field'}
        />
          <button type="button" className="cx-done" onClick={doneTyping}>{T.doneTyping}</button>
        </div>
      </div>
      <footer className="cx-hint">{T.hint}</footer>
      {toast && <div className="cx-toast" role="status">{toast}</div>}
    </div>
  );
}

// Route wrapper: the code comes from /c/:code; the .cxm wrapper scopes the page's colours.
export default function ConnectMobilePage() {
  const { code = '' } = useParams();
  useEffect(() => {
    const s = document.getElementById('splash-screen');
    if (s) s.style.display = 'none';
    document.body.classList.remove('page-loading');
  }, []);
  return (
    <div className="cxm">
      <ConnectPage code={code} />
    </div>
  );
}
